// extracted by mini-css-extract-plugin
export default {"auth_input":"styles_auth_input__tV45M","button_eye":"styles_button_eye__I7lTt","pass_input":"styles_pass_input__tpkiN"};